//--------------- IMPORTAÇÃOES ---------------//
import api from "../../../shared/services/api";



//--------------- FUNÇÃO ASSÍNCRONA CHECK ---------------//
// Responsável por requisitar à API o Check do usuário
// Se o user estiver autenticado, retorna verdadeiro, se não, falso
export default async function checkService() {
    try {
        await api.get("/auth/check");
        return true;
    } catch (err) {
        return false;
    }
}